/*
  Filtering Search Controller

  Performs and clears searches for the filtering_search component

  EMITTED EVENTS
    filteringSearchSuccess (document) Emitted when a filtering search request completes successfully
      detail: {
        el:  the root element of this controller instance,
        url: the url that the request was successfully sent to,
        res: the response from the server
      }
*/

import { xhrRequest, createCustomEvent } from '../../../../javascript/shared/helpers';

export default class extends Controller {
  static targets = ['searchField', 'clearButton'];

  connect() {
    this.hideOrShowClearButton();
  }

  performSearch(event) {
    event && event.preventDefault();
    this.containerHTML = App.spinner();
    xhrRequest(this.url, 'get')
      .then(res => {
        document.dispatchEvent(createCustomEvent('filteringSearchSuccess', this.element, { url: this.url, res }));
        this.containerHTML = res.data;
      })
      .catch(() => this.containerHTML = this.errorMessage);
    this.hideOrShowClearButton();
  }

  clear(event) {
    this.searchFieldTarget.value = '';
    this.performSearch(event);
  }

  //
  // INTERNAL USE
  //

  hideOrShowClearButton() {
    if (this.searchFieldTarget.value) {
      !this.hasClearButtonTarget && App.Helpers.appendAfter(this.clearButton, this.searchFieldTarget);
    } else {
      this.hasClearButtonTarget && this.clearButtonTarget.remove();
    }
  }

  //
  // GETTERS AND SETTERS
  //

  get searchQuery() {
    return this.hasSearchFieldTarget ? this.searchFieldTarget.value : '';
  }

  get containerSelector() {
    return this.data.get('container-selector');
  }

  get container() {
    return this.containerSelector ? document.querySelector(this.data.get('container-selector')) : null;
  }

  get errorMessage() {
    return this.data.has('error-message') ? this.data.get('error-message') : 'No items match your search';
  }

  get url() {
    return this.data.has('url') ? App.Helpers.addParamsToURL(this.data.get('url'), { [this.searchQueryParamName]: this.searchQuery }) : '';
  }

  get searchQueryParamName() {
    return this.data.get('search-param-name') || 'search';
  }

  get selectContainerInResponse() {
    return ['1', true, 'true'].indexOf(this.data.get('select-container-in-response')) > -1;
  }

  set containerHTML(content) {
    if (this.container) {
      App.Helpers.setContentFromString(this.container, content, this.selectContainerInResponse ? this.containerSelector : null);
    }
  }

  get clearButton() {
    return `
      <button title="Clear Search" type="reset" class="clear-button" data-action="filtering-search#clear" data-${this.identifier}-target="clearButton">
        <i class="fa fa-lg fa-times"></i>
      </button>
    `;
  }
};



// WEBPACK FOOTER //
// ./app/components/searches/assets/javascript/filtering-search-controller.js